import { type TenantId } from './tenant-ids'
import { type TenantThemeConfig } from './types'
import { dhlPalette } from './dhl'
import { pplPalette } from './ppl'
import { DHLLogo } from '../../primitives/Logo/DHLLogo'
import { PPLLogo } from '../../primitives/Logo/PPLLogo'

/**
 * Registry that maps every TenantId to its theme configuration.
 * Each tenant's palette lives in its own file under `./dhl/`, `./ppl/`, etc.
 */
export const tenantThemes: Record<TenantId, TenantThemeConfig> = {
  /** Default DHL brand. */
  dhl: {
    palette: dhlPalette,
    logo: DHLLogo,
  },

  /** PPL brand. Add PPL-specific palette overrides in `./ppl/palette.ts`. */
  ppl: {
    palette: pplPalette,
    logo: PPLLogo,
  },
}
